import { ConstantMapping } from "./reportAndLogsRowTypes"

export const  constantMapping:ConstantMapping =  {
    "xlsx":"Excel",
    "img":"Image",
    "csv":"CSV"
}

export const logsPerPage = 10;

export const constColorMapping = {
    "xlsx":"aquamarine",
    "csv":"green",
    "img":"deepskyblue",
    " ":"red"
}

export const dropDownElements = ["All","User","SellinaAIQuery","Offers", "ProductDetails","Division","SecondaryProduct","SupplierMaster","OutletDetails", "Targets","PJPVisitPlan","GenericEntity","Asset","PaymentSubscription","ProductTag"];



